import { useEffect, useState, useCallback } from 'react';

const KEY = 'betohalics:prefers-large-text';

const readPref = () => {
    try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
};

const apply = (on) => {
    const root = document.documentElement;
    if (on) root.classList.add('a11y-big');
    else root.classList.remove('a11y-big');
};

/**
 * Player-controlled accessibility toggle.
 * When ON, every `.a11y-font` wrapper inherits a larger base font + larger
 * section headers + bigger chips + taller disclosure rows.
 */
export const useBigText = () => {
    const [enabled, setEnabled] = useState(() => readPref());

    useEffect(() => { apply(enabled); }, [enabled]);

    // Sync across tabs
    useEffect(() => {
        const onStorage = (e) => {
            if (e.key === KEY) setEnabled(e.newValue === '1');
        };
        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, []);

    const toggle = useCallback(() => {
        setEnabled((prev) => {
            const next = !prev;
            try { localStorage.setItem(KEY, next ? '1' : '0'); } catch { /* ignore */ }
            return next;
        });
    }, []);

    return { enabled, toggle };
};

export default useBigText;
